@if (aiConnectorService.teaserVisible()) {
  @if (expanded()) {
    <!-- Dismiss is a sibling, not a child, of the card button: nested interactive controls are invalid. -->
    <div class="relative w-full min-w-[204px] mb-4">
      <button
        type="button"
        class="flex flex-col gap-2 w-full p-3 rounded-2xl bg-shikenso-base-white text-left cursor-pointer"
        data-testid="ai-connector-teaser"
        (click)="onOpenClick()"
      >
        <span class="flex items-center gap-2">
          <app-icon-badge content="icons/message-chatbot.svg" [size]="32" [iconSize]="18" [borderRadius]="100" />
          <span class="px-2 py-1 rounded-full bg-shikenso-pink-base-12 text-xs font-medium">
            {{ 'shared.aiConnector.teaser.new' | translate }}
          </span>
        </span>

        <span class="text-sm font-bold">{{ 'shared.aiConnector.teaser.title' | translate }}</span>
        <span class="text-xs text-shikenso-purple-base-60">{{ textKey | translate }}</span>
        <span class="flex items-center gap-1 text-xs font-medium">
          {{ 'shared.aiConnector.teaser.connectNow' | translate }}
          <app-icon src="/icons/arrow-right.svg" alt="" [size]="12" />
        </span>
      </button>

      <button
        type="button"
        class="absolute top-4 right-3 flex items-center justify-center w-6 h-6 rounded-full hover:bg-[var(--hover-color)]"
        data-testid="ai-connector-teaser-dismiss"
        [attr.aria-label]="'shared.aiConnector.teaser.dismiss' | translate"
        (click)="onDismissClick()"
      >
        <app-icon src="/icons/close.svg" alt="Dismiss" [size]="12" />
      </button>
    </div>
  } @else {
    <button
      type="button"
      class="relative flex items-center justify-center w-9 h-9 ml-1 mb-4 rounded-full hover:bg-[var(--hover-color)]"
      data-testid="ai-connector-teaser-collapsed"
      matTooltipPosition="right"
      [attr.aria-label]="'shared.aiConnector.teaser.title' | translate"
      [matTooltip]="'shared.aiConnector.teaser.title' | translate"
      [matTooltipShowDelay]="100"
      [matTooltipHideDelay]="50"
      (click)="onOpenClick()"
    >
      <app-icon src="/icons/message-chatbot.svg" alt="AI" class="w-4 h-4" />
      <span class="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-shikenso-pink-base"></span>
    </button>
  }
}
